import { NavLink, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useApp } from '../context/AppContext';
import { useTheme } from '../context/ThemeContext';

const tabs = [
  { to: '/', label: 'Home', icon: '🏠', end: true },
  { to: '/store', label: 'Store', icon: '🛍️' },
  { to: '/library', label: 'Library', icon: '📚' },
  { to: '/profile', label: 'Profile', icon: '👤' },
];

export function Layout() {
  const { cart, user } = useApp();
  const { theme, toggle } = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const initials = (user?.name ?? 'L')
    .split(' ')
    .map((s) => s[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();

  return (
    <div>
      <header className="header">
        <div className="container header-inner">
          <NavLink to="/" className="brand">
            📚 PulsePrep
          </NavLink>
          <nav className="nav">
            {tabs.map((t) => (
              <NavLink key={t.to} to={t.to} end={t.end} className={({ isActive }) => (isActive ? 'active' : '')}>
                {t.label}
              </NavLink>
            ))}
          </nav>
          <div className="spacer" />
          <button
            className="icon-btn"
            onClick={toggle}
            aria-label={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
            title={theme === 'dark' ? 'Light mode' : 'Dark mode'}
          >
            {theme === 'dark' ? '☀️' : '🌙'}
          </button>
          <button className="icon-btn" onClick={() => navigate('/cart')} aria-label="Cart">
            🛒
            {cart.length > 0 && <span className="cart-badge">{cart.length}</span>}
          </button>
          <button className="avatar" onClick={() => navigate('/profile')} aria-label="Profile">
            {initials}
          </button>
        </div>
      </header>

      <main className="container page">
        <Outlet />
      </main>

      {/* mobile bottom tabs */}
      <nav className="tabbar">
        {tabs.map((t) => {
          const active = t.end ? location.pathname === '/' : location.pathname.startsWith(t.to);
          return (
            <NavLink key={t.to} to={t.to} className={active ? 'active' : ''}>
              <span className="tab-ico">{t.icon}</span>
              {t.label}
            </NavLink>
          );
        })}
      </nav>
    </div>
  );
}
